export interface BlacklistsState {
    blacklists: BlacklistItem[]
    blacklistItem?: BlacklistItem
    blacklistContacts: BlacklistContactItem[]
    blacklistContactItem?: BlacklistContactItem
}

export interface BlacklistFilter {
    name?: string,
}

export class BlacklistItem {
    blackListId?: number
    id?: number
    create_date?: string
    name?: string
    comment?: string
    contacts?: number
    checkDuplicatesPolicy?: number = 3
}

export interface BlacklistContactItem {
    id?: number,
    create_date?: string,
    msisdn?: string,
    email?: string,
    description?: string,
}

export class BlacklistContactsFilter {
    blackListId?: string = undefined
    msisdn?: string = undefined
    email?: string = undefined
    page_number?: number = 1

    constructor(blackListId: string) {
        this.blackListId = blackListId
    }
}

export class BlacklistImportRequest {
    blackListId: number|null = null
    fileName: string|null = null
    file: string|null = null
    separator: string = ','
    uniquenessPolicy: number = 1
    fieldSequence: Array<string> = []

    constructor(blackListId: number) {
        this.blackListId = blackListId
    }
}
